import React, { Fragment, useContext, useEffect, useState, useMemo, useCallback } from 'react';
import { TableSectionV2 } from 'components/UI';
import localization from 'assets/localization/localization';
import { BaseUrl } from '../../../contexts/baseUrl/baseUrl';
import Layout from '../../sales/layout/layout';
import moment from 'moment';
import ListFilters from '../../sales/ListFilters/ListFilters';
import { Button } from 'react-bootstrap';
import Images from '../../../assets/images/imageData';
import { toast } from 'react-toastify';

const cell = (val) => (val != null && val !== '' ? String(val) : '—');

const BackToModificationList = ({
  getSendBackToModificationRequest,
  modificationRequestList = [],
  userRequestFilter,
  filterDetails = [],
  csvDownload,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [pageCount, setPageCount] = useState(0);
  const { baseUrl } = useContext(BaseUrl);
  const [listData, setListData] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [filterData, setFilterData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [roleId, setRoleId] = useState();

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      const getFilter = JSON.parse(localStorage.getItem('help_desk_back_finance_pending'));
      const storedPage = localStorage.getItem('page');
      setRoleId(localStorage.getItem('fusion-role'));
      let page;
      if (storedPage !== undefined && storedPage !== '' && storedPage !== null) {
        page = storedPage;
      } else {
        page = 1;
      }

      try {
        if (getFilter !== null && Object.keys(getFilter).length > 0) {
          await getSendBackToModificationRequest(page, getFilter);
        } else {
          await getSendBackToModificationRequest(page, null);
        }

        await userRequestFilter();
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  useEffect(() => {
    if (filterDetails?.status !== undefined) {
      delete filterDetails?.status;
    }
  }, [filterDetails]);

  const buildRowActions = useCallback(
    (row) => [
      {
        name: 'View',
        link: `${baseUrl}/request-view/${row.id}`,
      },
    ],
    [baseUrl]
  );

  const tableColumns = useMemo(
    () => [
      { key: 'request_id', label: 'Request Id', format: (val) => cell(val) },
      { key: 'request_name', label: 'Requester Name', format: (val) => cell(val) },
      {
        key: 'requested_date',
        label: 'Requested Date',
        format: (val) => {
          if (!val) return '—';
          const formatted = moment(val).format('DD-MMMM-YYYY');
          return formatted === 'Invalid date' ? '—' : formatted;
        },
      },
      { key: 'use_case_name', label: 'Finance use case', format: (val) => cell(val) },
      { key: 'a1_approval_name', label: 'Approver L1', format: (val) => cell(val) },
      { key: 'a2_approval_name', label: 'Approver L2', format: (val) => cell(val) },
      { key: 'PI_no', label: 'PI', format: (val) => cell(val) },
      { key: 'TI_no', label: 'TI', format: (val) => cell(val) },
      { key: 'designation_name', label: 'Designation', format: (val) => cell(val) },
      { key: 'department_name', label: 'Department', format: (val) => cell(val) },
      { key: 'status', label: 'Request Status', format: (val) => cell(val) },
      { key: 'finance_approval_name', label: 'Finance acted by', format: (val) => cell(val) },
      {
        key: 'actions',
        label: 'Actions',
        getActions: (row) => buildRowActions(row),
      },
    ],
    [buildRowActions]
  );

  const onPageChange = async (val) => {
    setIsLoading(true);
    localStorage.setItem('page', val.selected + 1);
    await getSendBackToModificationRequest(val.selected + 1, filterData);
    setIsLoading(false);
  };

  useEffect(() => {
    if (
      modificationRequestList &&
      modificationRequestList !== [] &&
      modificationRequestList.data &&
      modificationRequestList.data.length > 0
    ) {
      setListData(modificationRequestList.data);
      setPageCount(Math.ceil(modificationRequestList.total / modificationRequestList.per_page));
      setCurrentPage(modificationRequestList.current_page);
    } else if (modificationRequestList?.data !== undefined) {
      setListData([]);
      setPageCount(0);
    }
  }, [modificationRequestList]);

  const filterToggle = () => {
    setShowFilter(!showFilter);
  };

  const applyFilter = async (appliedFilterData) => {
    localStorage.setItem('help_desk_back_finance_pending', JSON.stringify(appliedFilterData));
    setIsLoading(true);
    setFilterData(appliedFilterData);
    setListData([]);
    await getSendBackToModificationRequest(1, appliedFilterData);
    setIsLoading(false);
    filterToggle();
  };

  const handleCsvDownload = async () => {
    setIsLoading(true);
    let filter = window.localStorage.help_desk_back_finance_pending
      ? JSON.parse(window.localStorage.help_desk_back_finance_pending)
      : null;
    let page = window.localStorage.page ? window.localStorage.page : 1;
    let res = await csvDownload(10, page, filter);
    setIsLoading(false);
    if (res) {
      window.open(res, '_blank');
    } else {
      toast.warning('No data found.');
    }
  };

  const srNo =
    modificationRequestList?.from ??
    (modificationRequestList?.current_page && modificationRequestList?.per_page
      ? (modificationRequestList.current_page - 1) * modificationRequestList.per_page + 1
      : 1);

  const headerBtns = () => {
    return (
      <Fragment>
        {parseInt(roleId) === 13 && (
          <Button
            onClick={handleCsvDownload}
            className="filter-hamburger show-btn btn btn-transparent"
          >
            {' '}
            <img src={Images?.download} alt="" />
            {'Download Csv'}
          </Button>
        )}
        <Button onClick={filterToggle} className="filter-hamburger show-btn btn btn-transparent">
          {' '}
          <img src={Images?.Filter} alt="" />
          {localization.showFilters}
        </Button>
      </Fragment>
    );
  };

  return (
    <Layout title={localization.hierarchyList} isLoading={isLoading} useNewHeaderLayout Buttons={headerBtns}>
      <TableSectionV2
        hideHeader
        hideTitleAndStatusFilter
        className="site-dashboard-table-section"
        tableData={listData}
        tableColumns={tableColumns}
        tableSectionProps={{ srNo }}
        pageCount={pageCount}
        currentPage={currentPage}
        onPageChange={onPageChange}
        isLoading={isLoading}
        emptyMessage="No requests found."
      />
      <ListFilters
        showFilter={showFilter}
        filterToggle={filterToggle}
        applyFilter={(val) => applyFilter(val)}
        listFilterData={filterDetails}
        helpdeskFilter={true}
        localstorageKey={'help_desk_back_finance_pending'}
      />
    </Layout>
  );
};

export default BackToModificationList;
